import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { white, blue } from '@bufferapp/ui/style/colors';

const Wrapper = styled.div`
  position: relative;
`;

const StyledTitle = styled.h4`
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  margin-top: -12px;
`;

const StyledSvg = styled.svg`
  transform: rotate(-90deg);
`;

const CIRCUMFERENCE = 297;

export const ProgressIndicator: React.FC<{ percentage: number }> = ({
  percentage,
}) => (
  <Wrapper>
    <StyledTitle>{`${percentage}%`}</StyledTitle>
    <StyledSvg
      className="progressIndicator"
      width="100"
      height="100"
      viewBox="0 0 100 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M97.5 49C97.5 74.9383 76.2527 96 50 96C23.7473 96 2.5 74.9383 2.5 49C2.5 23.0617 23.7473 2 50 2C76.2527 2 97.5 23.0617 97.5 49Z"
        stroke={white}
        strokeWidth="4"
      />
      <path
        d="M97.5 49C97.5 74.9383 76.2527 96 50 96C23.7473 96 2.5 74.9383 2.5 49C2.5 23.0617 23.7473 2 50 2C76.2527 2 97.5 23.0617 97.5 49Z"
        stroke={blue}
        strokeWidth="4"
        strokeDashoffset={CIRCUMFERENCE - CIRCUMFERENCE * (percentage / 100)}
        strokeDasharray={CIRCUMFERENCE}
      />
    </StyledSvg>
  </Wrapper>
);

ProgressIndicator.propTypes = {
  percentage: PropTypes.number.isRequired,
};
